import { Badge } from "@/components/ui/badge";
import { applyCpfMaskIfNeeded } from "@/utils/cpf-mask";
import { ColumnDef } from "@tanstack/react-table";
import { TermRequest } from "../data/types";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";

const statusConfig: Record<string, { label: string; variant: string }> = {
  APPROVED: { label: "Aprovado", variant: "bg-green-500 text-white" },
  REJECTED: { label: "Rejeitado", variant: "bg-red-500 text-white" },
  PENDING: { label: "Pendente", variant: "bg-yellow-500 text-white" },
  TERM_SIGNED: { label: "Assinado", variant: "bg-blue-500 text-white" },
  TERM_PENDING_SIGNATURE: { label: "Assinatura Pendente", variant: "bg-orange-500 text-white" },
  CANCELED: { label: "Cancelado", variant: "bg-gray-500 text-white" },
};

export const COLUMN_TO_DB_FIELD: Record<string, string> = {
  "Nome": "user_name",
  "CPF": "cpf",
  "Loja": "store_code",
  "Status": "status",
  "Data da Solicitação": "treasury_audit_date",
};

export const columns: ColumnDef<TermRequest>[] = [
  {
    id: "Nome",
    accessorKey: "user_name",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Nome" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex justify-center">{row.original.user_name}</div>
    ),
  },
  {
    id: "CPF",
    accessorKey: "cpf",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="CPF" />
      </div>
    ),
    cell: ({ row }) => {
      const cpf = row.original.cpf;
      return <div className="flex justify-center">{cpf ? applyCpfMaskIfNeeded(cpf) : "-"}</div>;
    },
  },
  {
    id: "Loja",
    accessorKey: "store_code",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Loja " />
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex justify-center">{row.original.store_code}</div>
    ),
  },
  {
    id: "Status",
    accessorKey: "status",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Status" />
      </div>
    ),
    cell: ({ row }) => {
      const status = row.original.status;
      const comment = row.original.comment;
      const config = statusConfig[status] || { label: status, variant: "bg-gray-500 text-white" };

      return (
        <div className="text-center flex flex-col items-center gap-1">
          <Badge
            className={config.variant}
            style={{ pointerEvents: "none" }}
          >
            {config.label}
          </Badge>
          {status === "REJECTED" && comment && (
            <span className="text-xs text-muted-foreground">
              Motivo: {comment}
            </span>
          )}
        </div>
      );
    },
  },
  {
    id: "Data da Solicitação",
    accessorKey: "treasury_audit_date",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Data da Solicitação" />
      </div>
    ),
    cell: ({ row }) => {
      const date = row.original.treasury_audit_date;
      const formattedDate = date
        ? new Date(date).toLocaleDateString("pt-BR")
        : "-";

      return <div className="flex justify-center">{formattedDate}</div>;
    },
  },
  {
    id: "actions",
    cell: ({ row }) => (
      <div className="flex justify-center">
        <DataTableRowActions row={row} />
      </div>
    ),
  },
];